import { jsxs as l, jsx as e } from "react/jsx-runtime";
import C from "../svg-icon/svg-icon.component.js";
function n(d) {
  return /* @__PURE__ */ l(C, { width: "24", height: "25", viewBox: "0 0 24 25", ...d, children: [
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 3.75C5.30964 3.75 4.75 4.30964 4.75 5V19C4.75 19.6904 5.30964 20.25 6 20.25H9.875C10.2892 20.25 10.625 20.5858 10.625 21C10.625 21.4142 10.2892 21.75 9.875 21.75H6C4.48122 21.75 3.25 20.5188 3.25 19V5C3.25 3.48122 4.48122 2.25 6 2.25H14C15.5188 2.25 16.75 3.48122 16.75 5V11C16.75 11.4142 16.4142 11.75 16 11.75C15.5858 11.75 15.25 11.4142 15.25 11V5C15.25 4.30964 14.6904 3.75 14 3.75H6Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 2.25C7.91421 2.25 8.25 2.58579 8.25 3V4.75H11.75V3C11.75 2.58579 12.0858 2.25 12.5 2.25C12.9142 2.25 13.25 2.58579 13.25 3V5C13.25 5.69036 12.6904 6.25 12 6.25H8C7.30964 6.25 6.75 5.69036 6.75 5V3C6.75 2.58579 7.08579 2.25 7.5 2.25Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.998 12.5001C16.4122 12.5001 16.748 12.8359 16.748 13.2501V13.7503C16.748 14.1645 16.4122 14.5003 15.998 14.5003C15.5838 14.5003 15.248 14.1645 15.248 13.7503V13.2501C15.248 12.8359 15.5838 12.5001 15.998 12.5001Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.998 22.0042C16.4122 22.0042 16.748 22.3399 16.748 22.7542V23.2544C16.748 23.6686 16.4122 24.0044 15.998 24.0044C15.5838 24.0044 15.248 23.6686 15.248 23.2544V22.7542C15.248 22.3399 15.5838 22.0042 15.998 22.0042Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.0648 14.1854C20.3577 14.4783 20.3577 14.9531 20.0648 15.246L19.7097 15.6012C19.4168 15.8941 18.9419 15.8941 18.649 15.6012C18.3561 15.3083 18.3561 14.8334 18.649 14.5405L19.0041 14.1854C19.297 13.8925 19.7719 13.8925 20.0648 14.1854Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.347 20.9033C13.6399 21.1962 13.6399 21.671 13.347 21.9639L12.9919 22.3191C12.699 22.612 12.2241 22.612 11.9312 22.3191C11.6383 22.0262 11.6383 21.5513 11.9312 21.2584L12.2864 20.9033C12.5793 20.6104 13.0541 20.6104 13.347 20.9033Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7498 18.2522C19.7498 17.838 20.0856 17.5022 20.4998 17.5022H21.0001C21.4143 17.5022 21.7501 17.838 21.7501 18.2522C21.7501 18.6664 21.4143 19.0022 21.0001 19.0022H20.4998C20.0856 19.0022 19.7498 18.6664 19.7498 18.2522Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2459 18.2522C10.2459 17.838 10.5817 17.5022 10.9959 17.5022H11.4961C11.9104 17.5022 12.2461 17.838 12.2461 18.2522C12.2461 18.6664 11.9104 19.0022 11.4961 19.0022H10.9959C10.5817 19.0022 10.2459 18.6664 10.2459 18.2522Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.649 20.9033C18.9419 20.6104 19.4168 20.6104 19.7097 20.9033L20.0648 21.2584C20.3577 21.5513 20.3577 22.0262 20.0648 22.3191C19.7719 22.612 19.297 22.612 19.0041 22.3191L18.649 21.9639C18.3561 21.671 18.3561 21.1962 18.649 20.9033Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9312 14.1854C12.2241 13.8925 12.699 13.8925 12.9919 14.1854L13.347 14.5405C13.6399 14.8334 13.6399 15.3083 13.347 15.6012C13.0541 15.8941 12.5793 15.8941 12.2864 15.6012L11.9312 15.246C11.6383 14.9531 11.6383 14.4783 11.9312 14.1854Z"
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.998 16.8964C15.2491 16.8964 14.6421 17.5034 14.6421 18.2522C14.6421 19.0011 15.2491 19.6081 15.998 19.6081C16.7468 19.6081 17.3538 19.0011 17.3538 18.2522C17.3538 17.5034 16.7468 16.8964 15.998 16.8964ZM13.1421 18.2522C13.1421 16.675 14.4207 15.3964 15.998 15.3964C17.5752 15.3964 18.8538 16.675 18.8538 18.2522C18.8538 19.8295 17.5752 21.1081 15.998 21.1081C14.4207 21.1081 13.1421 19.8295 13.1421 18.2522Z"
      }
    )
  ] });
}
export {
  n as DownloadAppIcon
};
//# sourceMappingURL=download-app.js.map
